/**
 * This file was automatically generated by @cosmwasm/ts-codegen@1.12.1.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run the @cosmwasm/ts-codegen generate command to regenerate this file.
 */

export interface InstantiateMsg {
  fee_percentage: number;
  registry_addr: string;
}
export type ExecuteMsg =
  | {
      lock_funds: {
        auth_token: string;
        expires: number;
        max_fee: Uint128;
        tool_id: string;
      };
    }
  | {
      release: {
        escrow_id: number;
        usage_fee: Uint128;
      };
    }
  | {
      refund_expired: {
        escrow_id: number;
      };
    }
  | {
      claim_fees: {
        denom?: string | null;
      };
    };
export type Uint128 = string;
export type QueryMsg =
  | {
      get_escrow: {
        escrow_id: number;
      };
    }
  | {
      get_collected_fees: {};
    }
  | {
      get_escrows: {
        caller?: string | null;
        limit?: number | null;
        provider?: string | null;
        start_after?: number | null;
      };
    };
export type Addr = string;
export interface CollectedFeesResponse {
  collected_fees: [string, Uint128][];
  fee_percentage: number;
  owner: Addr;
}
export interface EscrowResponse {
  auth_token: string;
  caller: Addr;
  denom: string;
  escrow_id: number;
  expires: number;
  max_fee: Uint128;
  provider: Addr;
}
export interface EscrowsResponse {
  escrows: EscrowResponse[];
}
